import React, { useCallback } from 'react'
import GridButton from './GridButton'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'react-feather'
import * as SelectionLayer from '../../map/layers/SelectionLayer'
import * as ComplexParcelDetailsLayer from '../../map/layers/ComplexParcelDetailsLayer'

const BackButton: React.FC = () => {
  const navigate = useNavigate()

  const handleBackButton = useCallback(() => {
    // Navigate back to the list view using React Router history.
    SelectionLayer.clearFocus()
    ComplexParcelDetailsLayer.clearGraphics()
    navigate('/search')
  }, [navigate])

  return (
    <GridButton
      Icon={ArrowLeft}
      onClick={handleBackButton}
      buttonText="Back to List"
    />
  )
}

export default BackButton